
function isNumberKeyEvent(evt){
    evt = (evt) ? evt : window.event
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
    } else {
        return true;
    }
}

function getCurrentMonthDataFromContract(frequencyQuantity) {
  // Validate
  if (!validateArray(frequencyQuantity))
    return null;

  const now = new Date();
  for (const item of frequencyQuantity) {
    const until = new Date(item.until_date);
    if (now.getMonth() === until.getMonth() && now.getFullYear() === until.getFullYear())
      return item;
  }
}

function validateArray(array){
  if(!array || !Array.isArray(array) || !array.length)
    return false;
  return true;
}

function deepCopy(object){
  return JSON.parse(JSON.stringify(object));
}

function capitaliseFirstLetters(phrase) {
  let wordList = phrase.split(' ');
  let capitalisedWordList = wordList.map(word => word.charAt(0).toUpperCase() + word.slice(1));
  return capitalisedWordList.join(' ');
}

function formatStringToNumber(value) {
  if (value) {
    const value1 = value.toString().replace(/,/g, "");
    const value2 = parseFloat(value1).toFixed(2);
    return parseFloat(value2);
  } else {
    return 0;
  }
}

function formatMonth(month) {
  if (month < 9) {
    return `0${(month + 1)}`
  }
  return `${month + 1}`
}

function formatDateAsDMY(dateString) {
  const date = new Date(dateString);
  return `${date.getDate()}/${formatMonth(date.getMonth())}/${date.getFullYear()}`;
}

export { isNumberKeyEvent, getCurrentMonthDataFromContract, validateArray, deepCopy, capitaliseFirstLetters, formatStringToNumber, formatDateAsDMY };

